var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(false);
      }
    }
  }, [_c('message-header', {
    attrs: {
      "message-header": _vm.messageHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sticky top-0 z-10"
  }, [_c('save-button', {
    staticClass: "right-15 top-15",
    attrs: {
      "saving": _vm.saving
    },
    on: {
      "save": _vm.saveBeneficiaryTemplates
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Gérer les modèles de pages de "), _c('br'), _vm._v(_vm._s(_vm.beneficiaryToEdit.firstname) + " "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.beneficiaryToEdit.lastname))])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-6 mt-15 mb-10"
  }, [_c('div', {
    staticClass: "col-span-full text-left text-indigo-600 text-base"
  }, [_vm._v("\n                    " + _vm._s("compétences personnelles".toUpperCase()) + "\n                ")]), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).compcle ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "compcle",
      "libelle": "Compétences clés",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).compcle,
      "datas": _vm.templates.filter(function (t) {
        return t.page == _vm.constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES;
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).compcle || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).compcle || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).compcle = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).informatique ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "informatique",
      "libelle": "Compétences informatiques",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).informatique,
      "datas": _vm.templates.filter(function (t) {
        return t.page == _vm.constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE;
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).informatique || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).informatique || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).informatique = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).langue ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "langue",
      "libelle": "Compétences linguistiques",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).langue,
      "datas": _vm.templates.filter(function (t) {
        return t.page == _vm.constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES;
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).langue || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).langue || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).langue = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-6 mt-15 mb-10"
  }, [_c('div', {
    staticClass: "col-span-full text-left text-indigo-600 text-base"
  }, [_vm._v("\n                    " + _vm._s("Compétences socio-professionnelles".toUpperCase()) + "\n                ")]), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).aptitudes_perso ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "aptitudes_perso",
      "libelle": "Aptitudes Personnelles",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).aptitudes_perso,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'aptitudes_perso';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).aptitudes_perso || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).aptitudes_perso || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).aptitudes_perso = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).comportement_social ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "comportement_social",
      "libelle": "Comportement Social et Relationnel",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).comportement_social,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'comportement_social';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).comportement_social || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).comportement_social || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).comportement_social = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).aptitudes_pro ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "aptitudes_pro",
      "libelle": "Aptitudes au travail",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).aptitudes_pro,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'aptitudes_pro';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).aptitudes_pro || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).aptitudes_pro || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).aptitudes_pro = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).productivite ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "productivite",
      "libelle": "Productivité et Technicité",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).productivite,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'productivite';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).productivite || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).productivite || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).productivite = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).attitudes_pro ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "attitudes_pro",
      "libelle": "Attitudes au Travail",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).attitudes_pro,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'attitudes_pro';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).attitudes_pro || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).attitudes_pro || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).attitudes_pro = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).regles ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "regles",
      "libelle": "Rapport aux règles et aux contraintes",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).regles,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'regles';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).regles || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).regles || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).regles = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), !_vm.isOF ? _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-6 mt-15 mb-10"
  }, [_c('div', {
    staticClass: "col-span-full text-left text-indigo-600 text-base"
  }, [_vm._v("\n                    " + _vm._s("Compétences professionnelles".toUpperCase()) + "\n                ")]), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).p1 ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "p1",
      "libelle": "Poste 1",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).p1,
      "datas": _vm.templates.filter(function (t) {
        return t.page == _vm.constants.PAGE_NEOPASS_FORM_POSTE_1;
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).p1 || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).p1 || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).p1 = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).p2 ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "p2",
      "libelle": "Poste 2",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).p2,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'p2';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).p2 || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).p2 || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).p2 = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).p3 ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "p3",
      "libelle": "Poste 3",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).p3,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'p3';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).p3 || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).p3 || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).p3 = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).p4 ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "p4",
      "libelle": "Poste 4",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).p4,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'p4';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).p4 || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).p4 || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).p4 = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).p5 ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "p5",
      "libelle": "Poste 5",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).p5,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'p5';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).p5 || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).p5 || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).p5 = newValue;
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.isOF ? _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-6 mt-15 mb-10"
  }, [_c('div', {
    staticClass: "col-span-full text-left text-indigo-600 text-base"
  }, [_vm._v("\n                    " + _vm._s("Compétences professionnelles".toUpperCase()) + "\n                ")]), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).f1 ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "f1",
      "libelle": "Formation 1",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).f1,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'f1';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).f1 || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).f1 || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).f1 = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).f2 ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "f2",
      "libelle": "Formation 2",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).f2,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'f2';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).f2 || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).f2 || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).f2 = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).f3 ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "f3",
      "libelle": "Formation 3",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).f3,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'f3';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).f3 || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).f3 || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).f3 = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).f4 ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "f4",
      "libelle": "Formation 4",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).f4,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'f4';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).f4 || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).f4 || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).f4 = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.beneficiaryToEdit || {}).templates || {}).f5 ? _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "f5",
      "libelle": "Formation 5",
      "value-is-object": true,
      "value": ((_vm.beneficiaryToEdit || {}).templates || {}).f5,
      "datas": _vm.templates.filter(function (t) {
        return t.page == 'f5';
      }),
      "disabled": (((_vm.beneficiaryToEdit || {}).templates || {}).f5 || {}).inProgress,
      "error": (((_vm.beneficiaryToEdit || {}).templates || {}).f5 || {}).inProgress,
      "msg-error": "Une évaluation est en cours sur ce modèle",
      "empty-case": false
    },
    on: {
      "input": function (newValue) {
        ((_vm.beneficiaryToEdit || {}).templates || {}).f5 = newValue;
      }
    }
  }) : _vm._e()], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }